import DatePicker from '../date-picker/DatePicker';
import { ViewMode } from '../date-picker/enum';
export default class TimePicker extends DatePicker {
    getWrapperClassNames() {
        const { prefixCls } = this;
        return super.getWrapperClassNames(`${prefixCls}-time-picker-wrapper`);
    }
    getLimitWithType(limit, _minOrMax) {
        return limit;
    }
}
TimePicker.displayName = 'TimePicker';
TimePicker.defaultProps = {
    ...DatePicker.defaultProps,
    mode: ViewMode.time,
};
